import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ProductAttributeRequirementsDto } from './ProductAttributeRequirementsDto'
import { ProductAttributeValueDto } from './ProductAttributeValueDto'
/**
* Class ProductAttributeValueSlotDto
*  
*/
export class ProductAttributeValueSlotDto extends ActiveModel {

  /**
  * metadata
  * Метаданные атрибута<br>  */
  @ActiveField({
    factory: [ProductAttributeRequirementsDto, () => ProductAttributeRequirementsDto.create()]
  })
  metadata: ProductAttributeRequirementsDto = ProductAttributeRequirementsDto.create()


/**
  * @property values
  * Информация о текущих значениях атрибута<br>  */
  @ActiveField({
    factory: [ProductAttributeValueDto, () => []]
  })
  values: Array<ProductAttributeValueDto> = []
}
